export default {
  computed: {
    packageName() {
      return this.$route.params.packageName;
    },
  },
};
